import { createServiceToken } from "@nasam/kernel";

import type { GprsCommandsRepository } from "../features/gprs/domain";

// GPRS commands live beside the other shared contracts, so another module
// (Tracking's "Send GPRS command" card action) can open the Send form for a
// vehicle without importing across the GPRS module boundary.
export type { GprsCommandsRepository } from "../features/gprs/domain";
export { GPRS_CREATE, GPRS_VIEW } from "../features/gprs/gprsPermissions";
export {
  SendGprsCommandDialog,
  type SendGprsCommandDialogProps,
  type SendGprsCommandPreset,
} from "../features/gprs/presentation/SendGprsCommandDialog";

export const gprsCommandsRepositoryToken = createServiceToken<GprsCommandsRepository>(
  "gprs.commands-repository",
);
